import React from 'react'
import { IInputProps } from './types'


const Input: React.FC<IInputProps> = ({
  type = 'text',
  name,
  label,
  placeholder,
  isValid = true,
  value,
  inputHandler,
  pressHandler = () => { }
}) => {

  return (
    <div className='input-wrapper'>

      {label ? (
        <h6 className='input-label'>
          {label}
        </h6>
      ) : null}

      <input
        className={`input ${!isValid && 'invalid'}`}
        type={type}
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={inputHandler}
        onKeyPress={pressHandler}
      />
    </div>
  )
}

export default Input
